import type { DtsInboundKafkaDto } from '@dhl/mdp-api'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'
import { DataHeading, DataRow } from '~/modules/ppp/submodules/relations/components/data'

type Props = {
  config: DtsInboundKafkaDto
}
export const InboundKafka = ({ config }: Props) => (
  <>
    <DataHeading title="Inbound Kafka" />
    <DataRow title="createdOn" payload={presentDateOrDefault(config.createdOn)} />
    <DataRow title="inName" payload={config.inName} withCopy />
    <DataRow title="topicName" payload={config.topicName} withCopy />
    <DataRow title="groupInstanceId" payload={config.groupInstanceId} withCopy />
    {config.filterSettings?.description && (
      <DataRow title="filterSettings" payload={config.filterSettings?.description} withCopy multiline />
    )}
  </>
)
